import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../../../hooks'
import { FormikField } from '../../../../../../../Formik'
import { InputField } from '../../../../../../../Input'
import { USER_FORM_EMAIL_FIELD_MAX_LENGTH } from '../../../../../../../User'
import {
  APPLICANT_IDENTITY_FIELD_NAME_EMAIL,
  QA_NAME_APPLICANT_IDENTITY_EMAIL_INPUT,
} from '../../../ApplicantIdentityWidget.constants'

function ApplicantIdentityEmailField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Inhabitant.EmailLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={USER_FORM_EMAIL_FIELD_MAX_LENGTH}
      name={APPLICANT_IDENTITY_FIELD_NAME_EMAIL}
      placeholder={t('Inhabitant.EmailPlaceholderKey')}
      qaName={QA_NAME_APPLICANT_IDENTITY_EMAIL_INPUT}
    />
  )
}

export default ApplicantIdentityEmailField
